import SplashScreen from "@/components/SplashScreen";
import Auth from "@/context/Auth";
import useDarkMode from "@/hooks/useDarkMode";
import Error500 from "@/pages/errors/Error500Page";
import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    if (document.documentElement) {
      document.documentElement.classList.toggle("dark", isDarkMode);
    }
  }, [isDarkMode]);
  return (
    <Suspense fallback={<SplashScreen />}>
      <Auth>
        <Outlet />
      </Auth>
    </Suspense>
  );
};

export default AppLayout;
